export const FirebaseConfig = {
	"projectId": "exicube-test-delivery",
	"appId": "1:962109078552:web:82b784763c034691cd176d",
	"databaseURL": "https://exicube-test-delivery-default-rtdb.firebaseio.com",
	"storageBucket": "exicube-test-delivery.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyBQbFdV-geMckRKryDnChIVwmnyhK-LROs",
	"authDomain": "exicube-test-delivery.firebaseapp.com",
	"messagingSenderId": "962109078552",
	"measurementId": "G-XPRTJF3RDG",
	"projectNumber": "962109078552",
	"version": "2"
};